import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { useMutation } from "@tanstack/react-query";

export function useMutationVisitTotalReportCsv({
  api,
  tz,
}: {
  api: ApiType;
  tz: string;
}) {
  const csvMutation = useMutation({
    mutationFn: async ({
      startDate,
      endDate,
    }: {
      startDate?: string;
      endDate?: string;
    }) => {
      const utcStart = zonedTimeToUtc(startDate as string, tz);
      const utcEnd = zonedTimeToUtc(endDate as string, tz);
      const result = await api.accessApi.visitTotalReportCsv({
        dateFrom: utcStart,
        dateTo: utcEnd,
      });
      return result.data;
    },
  });
  return csvMutation;
}
